import { AxiosResponse } from 'axios';
import { SET_DATE_TIME_BANNERS, SET_DATE_TIME_BANNER, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_DATE_TIME_BANNER_ISLOADING,
  DELETE_DATE_TIME_BANNER,
  EDIT_DATE_TIME_BANNER,
  GET_DATE_TIME_BANNERS,
  REGISTER_DATE_TIME_BANNER,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import DateTimeBanner from '@/services/date_time_banner';
import { Module } from 'vuex';
import { EditDateTimeBanner, RegisterDateTimeBanner, GetDateTimeBanner } from '@/dtos/date_time_banner.dto';

const buildPaginationMeta = (metaData: any, payload: any) => {
  const perPage = Number(metaData?.perPage ?? payload?.limit ?? 20);
  const currentPage = Number(metaData?.currentPage ?? payload?.page ?? 1);
  const totalRecords = Number(metaData?.totalRecords ?? 0);
  const totalPages = Number(metaData?.totalPages ?? Math.max(Math.ceil(totalRecords / perPage), 1));

  return { currentPage, perPage, totalRecords, totalPages };
};

const dateTimeBanner: Module<any, {}> = {
  state: {
    dateTimeBanner: {
      data: null,
      isLoading: false,
    },
    dateTimeBanners: {
      data: null,
      metaData: null,
      isLoading: false,
    },
  },
  getters: {
    dateTimeBanner: (state: { dateTimeBanner: any }) => state.dateTimeBanner,
    dateTimeBanners: (state: { dateTimeBanners: any }) => state.dateTimeBanners,
  },
  mutations: {
    [SET_DATE_TIME_BANNER]: (
      state: { dateTimeBanner: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.dateTimeBanner.data = payload.data) : null,
        (state.dateTimeBanner.isLoading = payload.isLoading);
    },
    [SET_DATE_TIME_BANNERS]: (
      state: { dateTimeBanners: StateObject },
      payload: { data: null; metaData?: any; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.dateTimeBanners.data = payload.data) : null,
        payload.metaData != null ? (state.dateTimeBanners.metaData = payload.metaData) : null,
        (state.dateTimeBanners.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_DATE_TIME_BANNER]: async ({ commit }: any, payload: any) => {
      commit(SET_DATE_TIME_BANNER, { data: null, isLoading: true });

      const result: AxiosResponse = await DateTimeBanner.registerDateTimeBanner(
        payload as RegisterDateTimeBanner
      );

      if (result) {
        if (result.data.status) {
          commit(SET_DATE_TIME_BANNER, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_DATE_TIME_BANNER, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_DATE_TIME_BANNER, { isLoading: false });
        return false;
      }
    },
    [GET_DATE_TIME_BANNERS]: async ({ commit }: any, payload: any) => {
      commit(SET_DATE_TIME_BANNERS, { data: null, isLoading: true });

      const result: AxiosResponse = await DateTimeBanner.getDateTimeBanners(
        payload as GetDateTimeBanner
      );

      if (result) {
        if (result.data.status) {
          const records = Array.isArray(result.data.data) ? result.data.data : [];
          const metaData = buildPaginationMeta(result.data.metaData, payload);
          commit(SET_DATE_TIME_BANNERS, { data: records, metaData, isLoading: false });
          return true;
        }
        commit(SET_DATE_TIME_BANNERS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_DATE_TIME_BANNERS, { isLoading: false });
        return false;
      }
    },
    [EDIT_DATE_TIME_BANNER]: async ({ commit }: any, payload: any) => {
      commit(SET_DATE_TIME_BANNER, { data: null, isLoading: true });

      const result: AxiosResponse = await DateTimeBanner.editDateTimeBanner(
        payload as EditDateTimeBanner
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_DATE_TIME_BANNER, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_DATE_TIME_BANNER, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_DATE_TIME_BANNER, { isLoading: false });
        return false;
      }
    },
    [DELETE_DATE_TIME_BANNER]: async ({ commit }: any, payload: string) => {
      commit(SET_DATE_TIME_BANNER, { data: null, isLoading: true });

      const result: AxiosResponse = await DateTimeBanner.deleteDateTimeBanner(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_DATE_TIME_BANNER, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_DATE_TIME_BANNER, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_DATE_TIME_BANNER, { isLoading: false });
        return false;
      }
    },
    [CLEAR_DATE_TIME_BANNER_ISLOADING]: ({ commit }) => {
      commit(SET_DATE_TIME_BANNER, { isLoading: false });
      commit(SET_DATE_TIME_BANNERS, { isLoading: false });
    },
  },
};

export default dateTimeBanner;
